import { createTheme } from "@mui/material/styles";

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#E85936",
    },
    info: {
      main: "#93DA87",
    },
  },
  typography: {
    fontFamily: "inherit",
  },
});
